import { Component } from '@angular/core';
import { AuthService } from '../../services/auth-service.service';

/**
 * Where MSAL sends the user when sign-in does not complete (`loginFailedRoute` in app.module.ts).
 *
 * The common case now is an account that was deactivated in CRM: the API signs the user out, they
 * try to sign back in, and B2C turns them away because `accountEnabled` is false. Before this route
 * existed MSAL navigated to a path with no component and the app simply stopped.
 */
@Component({
  selector: 'app-login-failed',
  templateUrl: './login-failed.component.html',
  styleUrls: ['./login-failed.component.scss']
})
export class LoginFailedComponent {

  constructor(private authService: AuthService) { }

  /**
   * A failed sign-in can leave a half-written MSAL cache behind, which makes the next attempt fail
   * the same way. Signing out properly clears both that and the B2C session cookie.
   */
  signOut(): void {
    this.authService.logout('/login');
  }
}
